/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Select, SecurityHelper, Button } from 'sarsaparilla';
import values from 'lodash/values';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';
import { authModalActions } from 'shared-ui/auth/redux';
import { PERMIT, SEASON } from '../propTypes';
import { ALL_DIVISION_TO_TYPE_MAPPING } from '../utils/utils';

class FloridaOHVSidebar extends React.Component {
    static propTypes = {
        permit: PERMIT.isRequired,
        seasons: PropTypes.arrayOf(SEASON),
        pActions: PropTypes.object.isRequired,
        openLoginModal: PropTypes.func.isRequired,
        account: PropTypes.object,
        router: COMPAT_ROUTER_PROP_TYPES,
    };
    constructor(props) {
        super(props);
        this.state = {
            selectedPermitType: null,
            waitingForUserAccount: false,
        };

        this.continueClick = this.continueClick.bind(this);
        this.changePermitTypeSelection = this.changePermitTypeSelection.bind(this);
    }

    componentDidMount() {
        this.props.pActions.purgePendingReservations();
    }

    componentDidUpdate(prevProps) {
        if (
            SecurityHelper.isLoggedIn() &&
            this.state.waitingForUserAccount &&
            this.props.account &&
            prevProps.account !== this.props.account
        ) {
            this.setState({ waitingForUserAccount: false });
            this.continueClick();
        }
    }

    changePermitTypeSelection(event) {
        this.setState({ selectedPermitType: event.target.value });
    }

    continueClick() {
        const loggedin = SecurityHelper.isLoggedIn();
        if (!loggedin) {
            this.setState({ waitingForUserAccount: true });
            this.props.openLoginModal();
            return;
        }
        const account = SecurityHelper.getAccount();

        const { selectedPermitType } = this.state;
        if (selectedPermitType) {
            let startDate;
            const item = {
                division_id: selectedPermitType,
                permit_type: ALL_DIVISION_TO_TYPE_MAPPING[selectedPermitType],
                permit_id: this.props.permit.id,
                start_date: startDate,
                group_members: [
                    {
                        birth_date: '',
                        first_name: account.first_name,
                        middle_name: '',
                        last_name: account.last_name,
                    },
                ],
            };
            this.props.pActions.createPendingReservations([item]);
            this.props.router.navigate(
                `/vehiclepermits/${this.props.permit.id}/order/detail`
            );
        }
    }

    render() {
        const { permit, seasons } = this.props;
        const dropdownOptions = values(permit.divisions).map((div) => ({
            label: div.name,
            value: div.id,
        }));
        const couldContinue = !!this.state.selectedPermitType;
        return (
            <>
                <p>Before you get started, please select the length of your stay.</p>
                <Select
                    className="mb-4"
                    label="Permit Type"
                    id="dropdown-permit-type"
                    placeholder="Select a permit type"
                    options={dropdownOptions}
                    isDisabled={!seasons?.length}
                    onChange={this.changePermitTypeSelection}
                />
                <Button
                    onClick={this.continueClick}
                    className="rec-button-primary-large bottom-3"
                    shouldFitContainer
                    isDisabled={!couldContinue || !seasons?.length}
                >
                    Get Permits
                </Button>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openLoginModal: bindActionCreators(authModalActions.openLoginModal, dispatch),
    };
}

export default withCompatRouter(connect(null, mapDispatchToProps)(FloridaOHVSidebar));
